import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component TextStyleUnderlineIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <TextStyleUnderlineIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <TextStyleUnderlineIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const TextStyleUnderlineIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      data-testid="TextStyleUnderlineIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="M11.84 18Q10.45 18 9.3 17.67Q8.14 17.34 7.31 16.64Q6.47 15.94 6.01 14.85Q5.54 13.76 5.54 12.25V3H8.64V12.01Q8.64 12.94 8.87 13.62Q9.1 14.29 9.53 14.73Q9.96 15.17 10.57 15.37Q11.18 15.58 11.92 15.58Q12.68 15.58 13.31 15.36Q13.95 15.14 14.4 14.69Q14.86 14.24 15.11 13.55Q15.36 12.86 15.36 11.9V3H18.46V12.09Q18.46 13.61 17.97 14.72Q17.47 15.84 16.59 16.57Q15.71 17.3 14.5 17.65Q13.29 18 11.84 18Z"
        clipRule="evenodd"
      />
      <rect x="4" y="20" width="16" height="2" rx="1" />
    </svg>
  )
);
TextStyleUnderlineIcon.displayName = "TextStyleUnderlineIcon";
export default TextStyleUnderlineIcon;
